var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 19,
    cy: 23,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 13c0 2.42-1.72 4.44-4 4.9V20c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .55-.45 1-1 1s-1-.45-1-1c0-2.76 2.24-5 5-5s5 2.24 5 5zM8 7H5c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1zM12 10c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1zM12 14c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 2v2.96c0 .55-.45 1-1 1s-1-.45-1-1V2.5c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5v19c0 .28.21.5.49.5H15c.55 0 1 .45 1 1s-.45 1-1 1H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h14c1.1 0 2 .9 2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 18c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDrill);
export default __webpack_public_path__ + "static/media/question-drill.c2a1cfca56c71665b2569a3feb0c3fa2.svg";
export { ForwardRef as ReactComponent };